import TrackingFirstInteraction from "./trackingFirstInteraction";

const tracking = () => {
    return {
        initTracking: () => {
            const STORAGE_KEY = 'trk-fi'
            const   menuButtons = document.querySelectorAll(".header-container nav li a"),
                    carListBtn = document.querySelectorAll(".car-lists__card"),
                    confirmBtns = document.querySelectorAll(".page__confirm .container--btns a"),
                    tfiForm = document.querySelector("main.page__form form.form"),
                    confirmPage = document.querySelector(".page__confirm")

            menuButtons.forEach(elem => {
                // console.log(elem)
                elem.addEventListener("click", (e) => {
                    // console.log(e.target.className)
                    e.preventDefault()

                    switch (e.target.className) {
                        // Measure the number of clicks on the "RESERVEZ UN ESSAI" button
                        case "essai-btn":
                            console.log("essaie");
                            if (typeof _satellite != 'undefined') {
                                _satellite.track('TDAstarted');
                            }
                            break;
                        // Measure the number of clicks on "DEMANDER UNE BROCHURE"
                        case "brochure-btn":
                            if (typeof _satellite != 'undefined') {
                                _satellite.track('RFIstarted');
                            }
                            console.log("brochure");
                            break;
                        // Measure the number of clicks on "DEMANDER UNE OFFRE"
                        case "offre-btn":
                            if (typeof _satellite != 'undefined') {
                                _satellite.track('RFOstarted');
                            }
                            console.log("offre");
                            break;

                        case "inform-btn":
                            if (typeof _satellite != 'undefined') {
                                _satellite.track('ROIstarted');
                            }
                            console.log("informed");
                            break;

                        case "cmd-distance-btn":
                            if (typeof _satellite != 'undefined') {
                                _satellite.track('RFPstarted');
                            }
                            console.log("cmd-distance");
                            break;

                    }

                    location.href = elem.href
                })
            })


            confirmBtns.forEach(elem => {
                elem.addEventListener("click", (e) => {
                    let btn_type = e.target.getAttribute("data-btn-type");

                    switch (btn_type) {
                        // Measure the number of clicks on the "RESERVEZ UN ESSAI" button
                        case "TDA":
                            console.log("essaie");
                            if (typeof _satellite != 'undefined') {
                                _satellite.track('TDAstarted');
                            }
                            break;
                        // Measure the number of clicks on "DEMANDER UNE BROCHURE"
                        case "RFI":
                            if (typeof _satellite != 'undefined') {
                                _satellite.track('RFIstarted');
                            }
                            console.log("brochure");
                            break;
                        // Measure the number of clicks on "DEMANDER UNE OFFRE"
                        case "RFO":
                            if (typeof _satellite != 'undefined') {
                                _satellite.track('RFOstarted');
                            }
                            console.log("offre");
                            break;

                        case "KMI":
                            if (typeof _satellite != 'undefined') {
                                _satellite.track('ROIstarted');
                            }
                            console.log("informed");
                            break;

                    }
                })
            })

            document.addEventListener('click', function (event) {
                if (event.target.id == 'idzCallBoxCallInstantButton') {
                    if (typeof _satellite != 'undefined') {
                        _satellite.track('RFCconfirmed');
                    }
                }

                if (event.target.id == 'idz_fonline') {
                    if (typeof _satellite != 'undefined') {
                        _satellite.track('RFCstarted');
                    }
                }
            })


            //  Measure the number of clicks on a cta accessing a form
            if (carListBtn) {
                carListBtn.forEach(elem => {
                    elem.addEventListener("click", (e) => {

                        e.preventDefault()

                        if (typeof _satellite != 'undefined') {
                            _satellite.track('FormStarted');
                        }

                        var tfi = new TrackingFirstInteraction()
                        tfi.triggerFirstInteraction();

                        console.log("form started");
                        location.href = elem.href;
                    });
                });
            }

            if (tfiForm) {
                tfiForm.addEventListener('change', function () {
                    var tfi = new TrackingFirstInteraction()
                    tfi.triggerFirstInteraction();
                });
                var formInputs = tfiForm.querySelectorAll("input[type='text']")
                formInputs.forEach(elem => {
                    elem.addEventListener("keypress", (e) => {
                        var tfi = new TrackingFirstInteraction()
                        tfi.triggerFirstInteraction();
                    });
                })
            }

            if (confirmPage) {
                var tfi = new TrackingFirstInteraction()
                tfi.resetFirstInteractionStorage();
            }

        }
    };
};
export default tracking;
